import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import EditEmployeeModal from "../../../AdminComponent/EditEmployeeModal";
import { FaSearch } from "react-icons/fa";

import { COLOR, FONT} from "../../../../Config/Color";
import { Table } from "antd";
import { Api, BaseUrl } from "../../../../Config/Api";
import axios from "axios";
import { toast } from "react-toastify";

const PastEmployeePage = () => {
  const [query, setQuery] = useState("");
  const token = sessionStorage.getItem("authToken");
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {};
  const [editmodalOpen, setEditModalOpen] = useState(false);
  const [employee, setEmployee] = useState();
  const [inactiveEmployee, setInactiveEmployee] = useState([]);

  useEffect(() => {
    fetchAllInactiveEmployee();
  }, [employee]);

  const fetchAllInactiveEmployee = async () => {
    try {
      const responseData = await axios.get(
        `${BaseUrl}${Api.GET_ALL_INACTIVE_EMPLOYEE}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Company-ID": userDetails?.company_id,
          },
        }
      );

      if (responseData?.data?.authenticated === false) {
        toast.error(responseData?.data?.mssg[0], {
          position: "top-center",
          autoClose: 1000,
        });
      } else {
        if (responseData?.data?.valid === false) {
          toast.error(responseData?.data?.mssg[0], {
            position: "top-center",
            autoClose: 1000,
          });
        } else {
          //console.log("Inactive Employee Data:", responseData?.data?.data);
          setInactiveEmployee(responseData?.data?.data);
        }
      }
    } catch (error) {
      console.error("API call failed:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
    }
  };

  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };

  const columns = [
    {
      title: "SN.",
      dataIndex: "sn",
      key: "sn",
      render: (text, record, index) => index + 1,
      width: 60,
      fixed: "left",
    },

    {
      title: "NAME",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 230,
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={record?.image ? record.image :'/assets/img/user.png'}
            style={{
              width: 50,
              height: 50,
              marginRight: 10,
              borderRadius: 10,
              border: "2px solid #E2E8F099",
            }}
            alt={record?.name ? `${record.name}'s Photo` : "No Employee Photo"}

          />
          <span
            style={{
              fontFamily: FONT.INTER,
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "20px",
              color: COLOR.GRAY4,
            }}
          >
            {record.name}
          </span>
        </div>
      ),
    },

    {
      title: "EMP. CODE",

      dataIndex: "employee_code",
      key: "employee_code",
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "EMAIL ID",
      dataIndex: "email",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "CONTACT",
      dataIndex: "mobile",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "MARITAL STATUS",
      dataIndex: "marital_status",
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text == null ? "N/A" : text}
        </span>
      ),
    },
    {
      title: "ADDRESS",
      dataIndex: "location",
      filtering: false,
      width: 200,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "DESIGNATION",
      dataIndex: "designation",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "EXP. LEVEL",
      dataIndex: "experience",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "TOTAL EXP",
      field: "total_experience",
      width: 150,
      render: (_, rowData) =>
        rowData.total_experience === null ? "NA" : rowData.total_experience,
      filtering: false,
    },
    {
      title: "DATE OF BIRTH",
      dataIndex: "dob",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "DATE OF JOINING",
      dataIndex: "doj",
      filtering: false,
      width: 180,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "DATE OF LEAVING",
      dataIndex: "leaving_date",
      filtering: false,
      width: 180,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "DEPARTMENT",
      dataIndex: "department",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "REPORTING MANAGER",
      dataIndex: "reporting_manager",
      filtering: false,
      width: 200,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "EMP. STATUS",
      dataIndex: "status",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "INACTIVE COMMENTS",
      dataIndex: "inactive_comments",
      filtering: false,
      width: 250,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text == null ? "N/A" : text}
        </span>
      ),
    },
    {
      title: "SHIFT TIMING ",
      dataIndex: "shift_timing",
      filtering: false,
      width: 150,
      render: (text) => (
        <span
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            display: "block", // Ensures it takes full width
            overflowWrap: "break-word",
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "OFFICE LOCATION",
      dataIndex: "office_location",
      width: 200,
      filtering: false,
    },
    {
      title: "ACTION",
      filtering: false,
      width: 100,
      render: (_, rowData) => (
        <div>
          <button
            className="action-button"
            onClick={() => editEmployeeDetails(rowData)}
          >
            <FaEdit />
          </button>
        </div>
      ),
    },
  ];
  const editEmployeeDetails = (empData) => {
    setEmployee(empData);
    setEditModalOpen(true);
  };
  return (
    <div
      className="  border-gray-300 px-5 py-5 bg-white rounded-lg shadow-sm"
      style={{
        maxHeight: "80vh", // Adjust height as needed
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <div className="flex items-center justify-between ">
        <div
          style={{
            width: 350,
            height: 40,
            display: "flex",
          }}
        >
          <div className="current_searchBar-wrapper">
            <input
              type="text"
              id="search-query"
              name="query"
              value={query}
              onChange={handleInputChange}
              placeholder="Search..."
              autoComplete="current-query"
              className="current_searchBar-input"
            />
            <FaSearch className="current_search-icon" />
          </div>
        </div>
      </div>
      <div
        style={{
          marginTop: "20px",
          width: "100%",
        }}
      >
        <div
          style={{
            marginTop: "20px",
            width: "100%",

            overflowX: "auto",
          }}
        >
          <Table
            dataSource={inactiveEmployee?.filter((item) => {
              if (query) {
                return (
                  item?.name?.toLowerCase().includes(query.toLowerCase()) ||
                  item?.employee_code
                    ?.toLowerCase()
                    .includes(query.toLowerCase()) ||
                  item?.email?.toLowerCase().includes(query.toLowerCase())
                );
              }
              return true;
            })}
            className="dotted-border-table"
            columns={columns}
            rowClassName={() => "custom-row"}
            bordered={false}
            tableLayout="fixed"
            rowKey="key"
            scroll={{ y: "70vh", x: 1000 }}
            pagination={false}
            locale={{
              emptyText: (
                <div className="custom-no-data">
                  No Past Employee Data Found
                </div>
              ),
            }}
          />
        </div>
      </div>

      <EditEmployeeModal
        open={editmodalOpen}
        onClose={() => setEditModalOpen(false)}
        user={employee}
      />
    </div>
  );
};

export default PastEmployeePage;
